export interface ChatInputInitialValues {
  messageType:  | null;
  message: string | null;
  currentContractCarName: string | null;
  currentContractCarRegistrationNumber: string | null;
  isLongTermContract: number;
  updatedContractCarName: string | null;
  yearAndMonthOfFirstRegistration: string | null;
  carModel: string | null;
  chassisNumber: string | null;
  carType: string | null;
  baseLocationForUse: string | null;
  carOwner: string | null;
  carOwnerKana: string | null;
  outOfPocketFeeFirstTime: number | null;
  outOfPocketFeeAfterSecondTime: number | null;
  updatedContractCarRegistrationNumber: string | null;
  updatedCarInsuranceFee: number | null;
  carInsuranceFeeNextYear: number | null;
  carInsuranceFeeThirdYear: number | null;
  isPersonalAndInsuranceStartTerm: number | null;
  updatedDriverSpecialContract: number | null;
  updatedDriverAgeConditionSpecialContract: number | null;
  addOrMinus: number | null;
  updatedInsuranceFee: number | null;
  updatedMonthlyInsuranceFee: number | null;
  aboutUpdatedInsuranceFee: number | null;
  aboutUpdatedInsuranceFeeDetail: string | null;
  updatedInsuranceFeeOfNextYear: number | null;
  paymentMethodOfNextYear: number | null;
  updatedInsuranceFeeOfThirdYear: number | null;
  paymentMethodOfThirdYear: number | null;
  newCarSpecialContractAddOrMinus: number | null;
  newCarSpecialContractUpdatedInsuranceFee: number | null;
  newCarSpecialContractUpdatedMonthlyInsuranceFee: number | null;
  newCarSpecialContractUpdatedInsuranceFeeOfNextYear: number | null;
  newCarSpecialContractPaymentMethodOfNextYear: number | null;
  newCarSpecialContractUpdatedInsuranceFeeOfThirdYear: number | null;
  newCarSpecialContractPaymentMethodOfThirdYear: number | null;
  remarks: string | null;
  carInsuranceType: number | null;
  carInsuranceRequest: number | null;
}

export const chatInputInitialValues: ChatInputInitialValues = {
  messageType: null,
  message: null,
  currentContractCarName: null,
  currentContractCarRegistrationNumber: null,
  isLongTermContract: 2,
  updatedContractCarName: null,
  yearAndMonthOfFirstRegistration: null,
  carModel: null,
  chassisNumber: null,
  carType: null,
  baseLocationForUse: null,
  carOwner: null,
  carOwnerKana: null,
  outOfPocketFeeFirstTime: null,
  outOfPocketFeeAfterSecondTime: null,
  updatedContractCarRegistrationNumber: null,
  updatedCarInsuranceFee: null,
  carInsuranceFeeNextYear: null,
  carInsuranceFeeThirdYear: null,
  isPersonalAndInsuranceStartTerm: null,
  updatedDriverSpecialContract: null,
  updatedDriverAgeConditionSpecialContract: null,
  addOrMinus: null,
  updatedInsuranceFee: null,
  updatedMonthlyInsuranceFee: null,
  aboutUpdatedInsuranceFee: null,
  aboutUpdatedInsuranceFeeDetail: null,
  updatedInsuranceFeeOfNextYear: null,
  paymentMethodOfNextYear: null,
  updatedInsuranceFeeOfThirdYear: null,
  paymentMethodOfThirdYear: null,
  newCarSpecialContractAddOrMinus: null,
  newCarSpecialContractUpdatedInsuranceFee: null,
  newCarSpecialContractUpdatedMonthlyInsuranceFee: null,
  newCarSpecialContractUpdatedInsuranceFeeOfNextYear: null,
  newCarSpecialContractPaymentMethodOfNextYear: null,
  newCarSpecialContractUpdatedInsuranceFeeOfThirdYear: null,
  newCarSpecialContractPaymentMethodOfThirdYear: null,
  remarks: null,
  carInsuranceType: null,
  carInsuranceRequest: null,
};
